import { Component, ElementRef, inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ReserveConfirmSurveyService } from '../../shared/services/reserve-confirm-survey.service';
import {
  Choice,
  EligibilityFormTempRequest,
  EligibilityQuestionnaireFieldRequest,
  ExamItemName,
  IndicationInfo,
  Question,
} from '../../shared/interfaces/reserve-confirm-survey.model';
import { MatCheckbox } from '@angular/material/checkbox';
import {
  BusinessExamInfo,
  BusinessPackageInfo,
  ExamInfo,
  Group,
  GroupInfo,
} from '../../shared/interfaces/reserve-loading.model';
import { AddExamInfo, ChangeItem, ExamItemInfo } from '../../shared/interfaces/reserve-add.model';
import { API_PARAMS } from '../../shared/constants/api.constants';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SingleActionDialogComponent } from '../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';
import { BMI, ID_LOGIN_TYPE, LOGIN_REGISTER_TABS } from '../../shared/constants/common.constants';
import { MatError, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {
  Answer,
  IndicationsQuestion,
} from '../../shared/interfaces/appointment-confirm.model';
import { MatButton } from '@angular/material/button';
import { NgOptimizedImage } from '@angular/common';
// import { environment } from '../../../environments/environment';
import { BmiDialogComponent } from '../../shared/components/dialogs/bmi-dialog/bmi-dialog.component';
import { ReserveAddService } from '../../shared/services/reserve-add.service';
import Decimal from 'decimal.js';
import { CheckReminderRequest } from '../../shared/interfaces/reserve-confirm-reminder.model';
import { ReserveConfirmReminderService } from '../../shared/services/reserve-confirm-reminder.service';
import { AuthService } from '../../shared/services/auth.service';

/**
 * 合適性問卷組件
 */
@Component({
  selector: 'app-reserve-confirm-survey',
  standalone: true,
  imports: [
    TranslatePipe,
    MatCheckbox,
    FormsModule,
    MatButton,
    MatError,
    NgOptimizedImage,
  ],
  templateUrl: './reserve-confirm-survey.component.html',
  styleUrl: './reserve-confirm-survey.component.scss',
})
export class ReserveConfirmSurveyComponent implements OnInit {
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  reserveConfirmSurveyService: ReserveConfirmSurveyService = inject(ReserveConfirmSurveyService);
  reserveAddService: ReserveAddService = inject(ReserveAddService);
  translateService: TranslateService = inject(TranslateService);
  authService: AuthService = inject(AuthService);
  reserveConfirmReminderService: ReserveConfirmReminderService = inject(ReserveConfirmReminderService);
  @ViewChildren('errorMsg') errorMsgRefs!: QueryList<ElementRef>;
  
  dialog: MatDialog = inject(MatDialog);
  router: Router = inject(Router);

  // 合適性清單
  indicationInfoList?: Array<IndicationInfo>;

  // 無法施作的檢項及其未通過的問題 { examItem: string, question: Array<Question & {questionnaireTypeId: string}> }
  invalidExamItemQuestionMap: Map<string, Array<Question & {questionnaireTypeId: string}>> = new Map();

  // 問題及對應的回答map { questionId: string, Y/N }
  questionAnswerMap: Map<string, string> = new Map();

  // 檢查項目map { examItem: string, ExamInfo | AddExamInfo | BusinessExamInfo }
  examItemMap: Map<string, ExamInfo | AddExamInfo | BusinessExamInfo> =
    new Map();

  // 組合檢項map { groupItem: string, Group }
  groupMap: Map<string, Group> = new Map();

  // 每個indicationInfo 以下皆非
  nonOfFollowings: Array<boolean> = [];

  // 身高
  height: string = '';
  // 體重
  weight: string = '';
  // 顯示錯誤訊息
  showError: boolean = false;

  // 活動折扣率
  partyDiscountRate: string = '';

  ngOnInit(): void {
     //   /* -----------2026.05.21 Bug0371修改----------- */
    const invalidExamQuestionMap = this.sharedStorageService.get('invalidExamQuestionMap');
    if(invalidExamQuestionMap) {
      this.router.navigate(['/healthcheck/reserve/reminder']).then();
    }
    
    // 設置當前預約步驟為5
    setTimeout(() => {
      this.sharedStorageService.set('reserveStep', 5);
    });

    const userPlanRequest = this.sharedStorageService.get('userPlanRequest');

    const questionAnswerMap = this.sharedStorageService.get('tempEligibilityQuestionAnswerMap');

    // 取得活動折扣率
    const partyDiscountRate = this.sharedStorageService.get('partyDiscountRate') ?? '';
    if (partyDiscountRate) {
      this.partyDiscountRate = partyDiscountRate;
    }

    // 如果有暫存的問卷回答狀態，則初始化questionAnswerMap
    if (questionAnswerMap) {
      Object.entries(questionAnswerMap).forEach(([key, value]) => {
        this.questionAnswerMap.set(key, value);
      });
    }

    const tempEligibilityNonOfFollowings = this.sharedStorageService.get('tempEligibilityNonOfFollowings');
    if (tempEligibilityNonOfFollowings) {
      this.nonOfFollowings = tempEligibilityNonOfFollowings;
      console.log("nonOfFollowings:", this.nonOfFollowings);
    }

    // 方案檢項
    let examItemNameList: Array<ExamItemName> = [];
    // 加選檢項
    const addExamItemNameList: Array<ExamItemName> =
      this.sharedStorageService
        .get('addExamItemList')
        ?.map((examItem: AddExamInfo) => ({
          examItem: examItem.examItem,
          examName: examItem.examName,
        })) ?? [];

    if (this.isPersonalReserve) {
      // 個人預約
      this.sharedStorageService
        .get('examItemList')
        ?.forEach((examItem: ExamInfo) => {
          examItemNameList.push({
            examItem: examItem.examItem,
            examName: examItem.examName,
            selectFlag: examItem.selectFlag,
          });
          // 初始化檢查項目map
          this.examItemMap.set(examItem.examItem, examItem);
        });
    } else {
      // 企業預約
      this.sharedStorageService.get('examItemList')?.forEach((examItem: ExamInfo) => {
        examItemNameList.push({
          examItem: examItem.examItem,
          examName: examItem.examName,
          selectFlag: examItem.selectFlag,
        });
        // 初始化檢查項目map
        this.examItemMap.set(examItem.examItem, examItem);
      });
    }

    // 初始化加選檢查項目map
    this.sharedStorageService
      .get('addExamItemList')
      ?.forEach((examItem: AddExamInfo) => {
        this.examItemMap.set(examItem.examItem, examItem);
      });

      const reserveType = this.sharedStorageService.get('reserveType');
      let isUpdate = '';

      // 個人
      if (reserveType === '1') {
        isUpdate = this.sharedStorageService.get('isUpdate') ?? '0';
      }else {
        // 企業統一帶 0
        isUpdate = '0';
      }

    let request: EligibilityQuestionnaireFieldRequest = {
      orgNo: userPlanRequest?.orgNo ?? '',
      gender: userPlanRequest?.gender ?? '',
      isUpdate: isUpdate,
      examItemList: this.sharedStorageService.get('examItemList')?.map((examInfo: ExamInfo) => ({
          examItem: examInfo.examItem,
          examName: examInfo.examName,
          selectFlag: examInfo.selectFlag ?? 1
        })) ?? [],
      addList: addExamItemNameList,
    };

    // 獲取合適性問卷問題
    this.reserveConfirmSurveyService
      .getQuestionnaireFields(request)
      .subscribe(res => {

        console.log("res.data：", res.data);

        if (res.statusCode === 'S0000' && res.data) {
          this.indicationInfoList = res.data.indicationInfos;
          // 如果沒有暫存的狀態，才初始化為 false
          if (!tempEligibilityNonOfFollowings) {
            this.nonOfFollowings = this.indicationInfoList?.map(() => false) ?? [];
          }

          // 根據恢復的"以下皆無"狀態，更新對應的問題回答
          this.nonOfFollowings.forEach((isNoneSelected, index) => {
            if (isNoneSelected && this.indicationInfoList?.[index]) {
              const indicationInfo = this.indicationInfoList[index];
              indicationInfo.questionList.forEach((question: Question) => {
                const questionKey = `${indicationInfo.questionnaireTypeId}-${question.questionId}`;
                this.questionAnswerMap.set(questionKey, API_PARAMS.NO);
              });
            }
          });

          if (res.data.indicationInfos.length === 0) {
            this.router.navigate(['/healthcheck/reserve/reminder']).then();
          }
        }

      });

    // 初始化不合規的問題(該問題在未勾選的情況下不能繼續)
    this.indicationInfoList?.forEach((indicationInfo: IndicationInfo) => {
      indicationInfo.questionList.forEach((question: Question) => {
        const questionKey = `${indicationInfo.questionnaireTypeId}-${question.questionId}`;

        // question的回答一開始為N
        this.questionAnswerMap.set(questionKey, API_PARAMS.NO);
        const isQuestionInvalid = question.choiceList.some(
          choice => choice.choiceResult === API_PARAMS.NO && !choice.isContinue
        );
        if (!isQuestionInvalid) {
          this.addInvalidQuestion(indicationInfo, question);
        }
      });
    });

    // 恢復暫存的無效檢項狀態
    const tempInvalidExamData = this.sharedStorageService.get('tempInvalidExamQuestionMap');
    if (tempInvalidExamData) {
      Object.entries(tempInvalidExamData).forEach(([key, value]) => {
        this.invalidExamItemQuestionMap.set(key, value as Array<Question & {questionnaireTypeId: string}>);
      });
    }
  }

  // // 把後端各式 indicationInfos 轉成前端統一格式
  // private normalizeIndicationInfos(raw: any): IndicationInfo[] {
  //   // 正式之後，因為沒有前端假資料，可以直接用後端回傳的格式就好
  //   /* ----------- 先把 raw 拆成陣列 infos ----------- */
  //   let infos: any[] = [];

  //   if (Array.isArray(raw)) {
  //     // 已經是一組陣列
  //     infos = raw;
  //   } else if (raw && typeof raw === 'object') {
  //     // 例：{ indicationInfos:[…] }
  //     if (Array.isArray(raw.indicationInfos)) {
  //       infos = raw.indicationInfos;

  //       // 例：{ success:…, data:{ indicationInfos:[…] } }
  //     } else if (raw.data && Array.isArray(raw.data.indicationInfos)) {
  //       infos = raw.data.indicationInfos;

  //       // 例：單一物件（極端防呆）
  //     } else {
  //       infos = [raw];
  //     }
  //   }

  //   /* ----------- 把 infos 每一筆轉成統一結構 ----------- */
  //   return infos.map((info): IndicationInfo => {
  //     // 後端仍是 examItemList（多檢查項合併）
  //     if (Array.isArray(info.examItemList)) {
  //       return {
  //         questionnaireTypeId: info.questionnaireTypeId ?? '',
  //         examItemList: info.examItemList ?? [],
  //         questionList: info.questionList ?? [],
  //       };
  //     }

  //     // 已經拆好成一筆一檢查項
  //     return {
  //       questionnaireTypeId: info.questionnaireTypeId ?? '',
  //       examItemList: info.examItemList ?? [],
  //       questionList: info.questionList ?? [],
  //     };
  //   });
  // }

  // 是否為個人預約
  get isPersonalReserve(): boolean {
    return (
      this.sharedStorageService.get('reserveType') === ID_LOGIN_TYPE.PERSONAL
    );
  }

  toggleChoice(
    checked: boolean,
    indicationInfo: IndicationInfo,
    question: Question,
    index: number
  ) {
    const questionKey = `${indicationInfo.questionnaireTypeId}-${question.questionId}`;
    
    if (checked) {
      this.questionAnswerMap.set(questionKey, API_PARAMS.YES);
      this.nonOfFollowings[index] = false;
      
      question.choiceList.forEach(choice => {
        if (choice.choiceResult === API_PARAMS.YES) {
          if (!choice.isContinue) {
            this.addInvalidQuestion(indicationInfo, question);
          } else {
            this.removeInvalidQuestion(indicationInfo, question);
          }
        }
      });
    } else {
      this.questionAnswerMap.set(questionKey, API_PARAMS.NO);
      
      question.choiceList.forEach(choice => {
        if (choice.choiceResult === API_PARAMS.NO) {
          if (!choice.isContinue) {
            this.addInvalidQuestion(indicationInfo, question);
          } else {
            this.removeInvalidQuestion(indicationInfo, question);
          }
        }
      });
    }
  }

  // 將不合規的問題添加到map中
  addInvalidQuestion(indicationInfo: IndicationInfo, question: Question) {
    if (!indicationInfo.examItemList) {
      return;
    }
    
    const questionWithTypeId = { ...question, questionnaireTypeId: indicationInfo.questionnaireTypeId };
    
    indicationInfo.examItemList.forEach(examItem => {
      const existingQuestions = this.invalidExamItemQuestionMap.get(examItem.examItem) || [];
      
      if (!existingQuestions.some(q => 
        q.questionId === question.questionId && 
        q.questionnaireTypeId === indicationInfo.questionnaireTypeId
      )) {
        this.invalidExamItemQuestionMap.set(examItem.examItem, [
          ...existingQuestions,
          questionWithTypeId,
        ]);
      }
    });
  }

  // 移除不合規的問題
  removeInvalidQuestion(indicationInfo: IndicationInfo, question: Question) {
    if (!indicationInfo.examItemList) {
      return;
    }
    
    indicationInfo.examItemList.forEach(examItem => {
      const questions = this.invalidExamItemQuestionMap.get(examItem.examItem);
      if (questions) {
        this.invalidExamItemQuestionMap.set(
          examItem.examItem,
          questions.filter(q => 
            !(q.questionId === question.questionId && 
              q.questionnaireTypeId === indicationInfo.questionnaireTypeId)
          )
        );
        if (
          this.invalidExamItemQuestionMap.get(examItem.examItem)?.length === 0
        ) {
          this.invalidExamItemQuestionMap.delete(examItem.examItem);
        }
      }
    });
  }

  // 檢查indicationInfo是否合規(有選擇以下皆無或是有勾選問題)
  get isIndicationValid(): (
    indicationInfo: IndicationInfo,
    index: number
  ) => boolean {
    return (indicationInfo: IndicationInfo, index: number): boolean => {
      return (
        this.nonOfFollowings[index] ||
        indicationInfo.questionList.some(
          question => {
            const questionKey = `${indicationInfo.questionnaireTypeId}-${question.questionId}`;
            return this.questionAnswerMap.get(questionKey) === API_PARAMS.YES;
          }
        )
      );
    };
  }

  // BMI
  get bmi(): string {
    const height = Number(this.height);
    const weight = Number(this.weight);
    if (!this.height || !this.weight || isNaN(height) || isNaN(weight)) {
      return '--';
    }
    // 計算到小數後2位
    return height > 0
      ? (
          Math.round((weight / ((height / 100) * (height / 100))) * 100) / 100
        ).toString()
      : '--';
  }

  // 未來可刪除此值
  bmiFromDiag = 0;
  openBmiCalculator (question: Question) {
    const bmiDiag = this.dialog.open(BmiDialogComponent, {
        data: {
          title: this.translateService.instant('reserve-confirm-survey.bmi-tool'),
          leftButtonText: this.translateService.instant('common.button.cancel'),
          rightButtonText: this.translateService.instant('common.button.confirm'),
          height: this.height,
          weight: this.weight,
        },
      });
    bmiDiag.afterClosed().subscribe(
      {
        next: (result) => {
          if (result) {
            this.height = result.height;
            this.weight = result.weight;
            this.bmiFromDiag = result.bmi;

            // 如果 BMI 超過 34，自動打勾對應 checkbox
          if (result.bmi >= 34) {
            // 需要找到對應的 indicationInfo 來構建正確的 questionKey
            const indicationInfo = this.indicationInfoList?.find(info => 
              info.questionList.some(q => q.questionId === question.questionId)
            );
            if (indicationInfo) {
              const questionKey = `${indicationInfo.questionnaireTypeId}-${question.questionId}`;
              this.questionAnswerMap.set(questionKey, API_PARAMS.YES);
            }
          }
          } else {
            // 需要找到對應的 indicationInfo 來構建正確的 questionKey
            const indicationInfo = this.indicationInfoList?.find(info => 
              info.questionList.some(q => q.questionId === question.questionId)
            );
            if (indicationInfo) {
              const questionKey = `${indicationInfo.questionnaireTypeId}-${question.questionId}`;
              this.questionAnswerMap.set(questionKey, API_PARAMS.NO);
            }
          }
        },
        error: (err) => {
          console.log(err);
          // if (!environment.production){
          //   console.log(err);
          // }
        }
      });

  }


  // 切換"以下皆無"選項
  toggleNonOfFollowing(index: number) {
    if (this.nonOfFollowings[index]) {
      // 如果勾選了"以下皆無"，則清空該indicationInfo下的所有問題回答
      const indicationInfo = this.indicationInfoList?.[index];
      if (indicationInfo) {
        indicationInfo.questionList.forEach((question: Question) => {
          const questionKey = `${indicationInfo.questionnaireTypeId}-${question.questionId}`;
          this.questionAnswerMap.set(questionKey, API_PARAMS.NO);
          // 勾選"以下皆無"時，移除所有相關的無效問題
          this.removeInvalidQuestion(indicationInfo, question);
        });
      }
    }
  }

  // 點擊"上一步"
  previous() {
    // 儲存目前的問卷回答狀態
    const questionAnswerObject: { [key: string]: string } = {};
    this.questionAnswerMap.forEach((value, key) => {
      questionAnswerObject[key] = value;
    });
    
    // 儲存當前無效檢項狀態
    const currentInvalidExamObject: { [key: string]: Array<Question & {questionnaireTypeId: string}> } = {};
    this.invalidExamItemQuestionMap.forEach((questions, examItem) => {
      currentInvalidExamObject[examItem] = questions;
    });

    this.sharedStorageService.set('tempEligibilityQuestionAnswerMap', questionAnswerObject);
    this.sharedStorageService.set('tempEligibilityNonOfFollowings', this.nonOfFollowings);
    this.sharedStorageService.set('tempInvalidExamQuestionMap', currentInvalidExamObject);
    this.router.navigate(['/healthcheck/reserve/overview']).then();
  }

  // 點擊"下一步"
  next() {
    this.showError = true;

    // 滾動到第一個錯誤訊息
    if (this.showError) {
      setTimeout(() => {
        const firstErrorElement = this.errorMsgRefs.first;
        if (firstErrorElement) {
          firstErrorElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }

    // 檢查每個indicationInfo下的問題是否有選擇
    const isValid = this.indicationInfoList?.every((indicationInfo, index) => {
      return this.isIndicationValid(indicationInfo, index);
    });
    if (!isValid) {
      console.log("尚未填完");
      return;
    }

    // 儲存合適性問卷結果(存localStorage)
    const indicationsQuestionList: Array<IndicationsQuestion> = [];
    this.indicationInfoList?.forEach((indicationInfo: IndicationInfo) => {
      const questionList = indicationInfo.questionList;
      const answerList: Array<Answer> = [];
      questionList.forEach((question: Question) => {
        question.choiceList.forEach((choice: Choice) => {
          const choiceId = choice.choiceId;
          const questionKey = `${indicationInfo.questionnaireTypeId}-${question.questionId}`;
          const answer = this.questionAnswerMap.get(questionKey) ?? API_PARAMS.NO;
          answerList.push({
            questionId: question.questionId,
            choiceId: choiceId,
            answer: answer,
          });
        });
      });

      const indicationsQuestion: IndicationsQuestion = {
        questionnaireTypeId: indicationInfo.questionnaireTypeId,
        examItem: indicationInfo.examItemList?.map(examItem => examItem.examItem) || [],
        answerList: answerList,
      };
      indicationsQuestionList.push(indicationsQuestion);
    });
    this.sharedStorageService.set(
      'indicationsQuestionList',
      indicationsQuestionList
    );

    // 儲存合適性問卷站存檔(CB-078)
    const eligibilityFormTempRequest : EligibilityFormTempRequest = {
      idNo: this.sharedStorageService.get('userPlanRequest')?.idNo ?? '',
      orgNo: this.sharedStorageService.get('userPlanRequest')?.orgNo ?? '',
      indicationsQuestionList: indicationsQuestionList,
    }

    // 儲存合適性問卷結果(存後端)
    this.reserveConfirmSurveyService.saveEligibilityFormTemp(eligibilityFormTempRequest).subscribe(res => {
      if (res.statusCode === 'S0000' && res.data?.isSaved === true) {
        console.log("儲存成功");
      } else {
        console.log("儲存失敗");
      }
    });


    // 確認是否有未能施作的項目 - 只檢查選擇方案底下的檢項
    const selectedInvalidItems = this.getSelectedInvalidItems();

    if (selectedInvalidItems.size === 0) {
      // 查詢有無檢前提醒
      const examItemNameList: Array<ExamItemName> =
        this.sharedStorageService.get('examItemList')?.map((examInfo: ExamInfo) => ({
          examItem: examInfo.examItem,
          examName: examInfo.examName,
          selectFlag: examInfo.selectFlag
        })) ?? [];

        const addExamItemNameList: Array<ExamItemName> =
          this.sharedStorageService
            .get('addExamItemList')
            ?.map((examItem: AddExamInfo) => ({
              examItem: examItem.examItem,
              examName: examItem.examName,
            })) ?? [];

        const request: CheckReminderRequest = {
          examItemList: examItemNameList,
          addList: addExamItemNameList,
        };

      this.reserveConfirmReminderService
        .checkReminders(request)
        .subscribe(res => {
          if (res.data?.reminderList && res.data.reminderList.length > 0) {
            this.router.navigate(['/healthcheck/reserve/reminder']).then();
          } else {
            const loginStatus = this.sharedStorageService.get('loginStatus');
            const createMemberRequest = this.sharedStorageService.get('createMemberRequest');

            // 查詢有無會員，沒有則去登入
            if (loginStatus === 'memberLogin' && createMemberRequest?.idNo && this.authService.isLogin()) {
              const modifyType = this.sharedStorageService.get('modifyType');
              if(modifyType === 'modifyExam'){
                //來自會員中心調整檢項
                this.router.navigate(['/healthcheck/reserve/timeselect']).then();
              } else {
                this.router.navigate(['/healthcheck/reserve/bookinfo']).then();
              }
            }
            else if (loginStatus === 'newFriend') {
              this.router
                .navigate(['/healthcheck/login'], {
                  queryParams: { tab: LOGIN_REGISTER_TABS.REGISTER },
                })
                .then();
            }else if (loginStatus === 'withHIS' || loginStatus === 'withoutHIS') {
              this.router
                .navigate(['/healthcheck/contactinfo'], {
                  queryParams: { backToAppointment: 'true' },
                })
                .then();
            }
          }
        });
    } else {
      // 個人預約 || 企業預約且不合格項目在加選項目
      if (this.isPersonalReserve || (!this.hasInvalidItemsInPackage(selectedInvalidItems) && this.hasInvalidAddItems(selectedInvalidItems))) {
        let message = `${this.translateService.instant('reserve-confirm-survey.invalid-dialog-message')} <br/>`;
        message += `<ul class="dialog-remind-msg">`;

        // 避免重複重複訊息
        const displayedMessages = new Set<string>();

        // 判斷不合格項目是否包含麻醉相關檢項
        let hasAnesthesiaInvalid = false;
        console.log( "selectedInvalidItems:" ,selectedInvalidItems);
        selectedInvalidItems.forEach((questions, examItem) => {
          // 檢查是否為麻醉相關檢項（可根據實際的麻醉檢項代碼調整）
          console.log("EXAMITEM:", examItem);
          if (examItem.includes('PE001006') || examItem.includes('PE001005') || examItem.includes('PE001000') || examItem.includes('PE001007')) {
            hasAnesthesiaInvalid = true;
          }
          const examName = this.examItemMap.has(examItem)
            ? this.examItemMap.get(examItem)?.examName
            : this.groupMap.get(examItem)?.groupName;

          questions.forEach(question => {
            const translated = this.translateService.instant(
              'reserve-confirm-survey.invalid-dialog-item-message',
              {
                questionName: question.questionName,
                examName: examName,
              }
            );

            if (!displayedMessages.has(translated)) {
              displayedMessages.add(translated);
              message += `<li>${translated}</li>`;
            }
          });
        });


        const requiredItemsRequest = {
          orgNo: this.sharedStorageService.get('userPlanRequest')?.orgNo ?? '',
          idNo: this.sharedStorageService.get('userPlanRequest')?.idNo ?? '',
          examItemList: this.sharedStorageService.get('examItemList')?.filter((examInfo: ExamInfo) =>
            !selectedInvalidItems.has(examInfo.examItem)).map((examInfo: ExamInfo) => ({
            examItem: examInfo.examItem,
            examName: examInfo.examName,
            selectFlag: examInfo.selectFlag ?? 1
          })) ?? [],
          addList: this.sharedStorageService.get('addExamItemList')?.filter((examInfo: AddExamInfo) =>
            !selectedInvalidItems.has(examInfo.examItem)).map((examInfo: AddExamInfo) => ({
            examItem: examInfo.examItem,
            examName: examInfo.examName,
          })) ?? [],
          callStage: 1, // 合適性問卷後固定帶 1
          anesConsent: 2, // 不須詢問麻醉固定帶 2
        };

        console.log('requiredItemsRequest:', requiredItemsRequest);

        message += `</ul>`;

        const dialog = this.dialog.open(SingleActionDialogComponent, {
          data: {
            title: this.translateService.instant(
              'reserve-confirm-survey.invalid-dialog-title'
            ),
            message: message,
            buttonText: this.translateService.instant(
              'common.button.i-understood'
            ),
            showCloseButton: false,
            action: () =>

              this.reserveAddService.requiredItems(requiredItemsRequest).subscribe(res => {
            if (res?.data) {
              // 有換項
              if (res?.data?.changeList && res.data.changeList.length > 0) {
                let examItemList = this.sharedStorageService.get('examItemList') ?? [];
                let originalExamItemList = this.sharedStorageService.get('originalExamItemList') ?? [];
                let addExamItemList = this.sharedStorageService.get('addExamItemList') ?? [];
                let removeItemQuestionMap = this.sharedStorageService.get('removeItemQuestionMap') ?? [];
                const examInfoListUnderPackage = this.sharedStorageService.get('originalExamItemList') ?? [];

                console.log("有換項 :", res.data.changeList);
                res.data.changeList.forEach((item: ChangeItem) => {
                  item.examItemList.forEach((examItem: ExamItemInfo) => {
                    // 將換項加入方案檢項中
                    examInfoListUnderPackage.push({
                      examName: examItem.examName ?? '',
                      examItem: examItem.examItem,
                      examPrice: examItem.price ?? '0',
                      examMemo: examItem.examMemo ?? '',
                      deptName: item.deptName,
                      rateStatus:examItem.rateStatus,
                      selectFlag: 1,
                      examType: this.translateService.instant('reserve-result.standard'),
                    });
                  });
                });

                // 若有移除麻醉項目
                if (res?.data?.removeAnesList && res.data.removeAnesList?.length > 0) {
                  console.log("有麻醉項目要移除 :", res.data.removeAnesList);

                  // 若在方案內，將方案內項目取消勾選
                  if (res?.data?.removeAnesList.some(removeItem => 
                      examItemList.some(item => item.examItem === removeItem.examItem)
                    )
                  ) {
                    console.log("麻醉項目在方案內，將方案內項目取消勾選");
                    res.data.removeAnesList.forEach(removeItem => {
                      originalExamItemList = originalExamItemList.map(item => {
                        if (item.examItem === removeItem.examItem) {
                          item.selectFlag = 0;
                        }
                        return item;
                      });
                    });
                    // 先計算原始總價
                    const originalTotalPrice = originalExamItemList.filter(item => (item.selectFlag ?? 1) === 1)
                      .reduce((total, item) => {
                        return total.add(new Decimal(item.examPrice ?? 0));
                      }, new Decimal(0));

                    console.log("originalTotalPrice:", originalTotalPrice.toString());

                    // 用原始總價計算折扣率
                    const discountRate = this.movedDiscountRate(originalTotalPrice);

                    // 再計算折扣後的金額
                    const discountedPackagePrice = originalExamItemList
                      .filter(examInfo => examInfo.selectFlag === 1)
                      .reduce((total, examInfo) => {
                        const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
                        if (examInfo.rateStatus === true) {
                          let discountedPrice = originalPrice.mul(discountRate);
                          let roundedPrice = discountedPrice.div(10).ceil().mul(10); // 無條件進位到十位數
                          // 若有活動折扣率
                          if (this.partyDiscountRate) {
                            roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
                            // 四捨五入到個位整數
                            roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
                          }
                          return total + roundedPrice.toNumber();
                        } else {
                          return total + originalPrice.toNumber();
                        }
                      }, 0);

                    res.data.removeAnesList.forEach(removeItem => {
                      const removedAnesthesiaItem = originalExamItemList.find(item => item.examItem === removeItem.examItem);
                      if (removedAnesthesiaItem && !removeItemQuestionMap.some(item => item.examItem === removedAnesthesiaItem.examItem)) {
                        removeItemQuestionMap.push(removedAnesthesiaItem);
                      }
                    });

                    console.log('discountedPackagePrice:', discountedPackagePrice);
                    console.log('removeItemQuestionMap:', removeItemQuestionMap);
                    this.sharedStorageService.set('originalPrice', discountedPackagePrice);
                    this.sharedStorageService.set('examItemList', originalExamItemList);
                    this.sharedStorageService.set('originalExamItemList', originalExamItemList);
                  }
                  // 若在加選檢項中，刪除加選方案內麻醉項目
                  else if (res?.data?.removeAnesList && res.data.removeAnesList.some(removeItem => 
                    addExamItemList.some(item => item.examItem === removeItem.examItem)
                  )) {
                    console.log("麻醉項目在加選中，將加選項目移除");
                    res.data.removeAnesList.forEach(removeItem => {
                      addExamItemList = addExamItemList.filter(item => item.examItem !== removeItem.examItem);
                    });
                    this.sharedStorageService.set('addExamItemList', addExamItemList);
                  }
                }

              // 將新加的麻醉項目加入加選檢項中
              if (res?.data?.addAnesList && res.data.addAnesList.length > 0) {
                console.log("有麻醉項目要加 :", res.data.addAnesList);
                let addExamItemList = this.sharedStorageService.get('addExamItemList') ?? [];
                let examItemList = this.sharedStorageService.get('examItemList') ?? [];
                let originalExamItemList = this.sharedStorageService.get('originalExamItemList') ?? [];
                let removeItemQuestionMap = this.sharedStorageService.get('removeItemQuestionMap') ?? [];

                res.data.addAnesList.forEach(addItem => {
                  addExamItemList.push({
                    examName: addItem.examName ?? '',
                    examItem: addItem.examItem,
                    examMemo: addItem.examMemo ?? '',
                    price: addItem.price ?? '0',
                    mutexInfos: [],
                    isNecessary: false,
                    isChoice: true,
                    disable: false,
                    examType: '',
                    deptName: '',
                    deptEName: '',
                  });
                });
                this.sharedStorageService.set('addExamItemList', addExamItemList);

                  // 若有移除麻醉項目
                  if (res?.data?.removeAnesList && res.data.removeAnesList.length > 0) {
                    console.log("有麻醉項目要移除 :", res.data.removeAnesList);

                    // 若在方案內，將方案內項目取消勾選
                    if (res?.data?.removeAnesList && res.data.removeAnesList.some(removeItem => 
                      examItemList.some(item => item.examItem === removeItem.examItem)
                    )) {
                      console.log("麻醉項目在方案內，將方案內項目取消勾選");
                      res.data.removeAnesList.forEach(removeItem => {
                        originalExamItemList = originalExamItemList.map(item => {
                          if (item.examItem === removeItem.examItem) {
                            item.selectFlag = 0;
                          }
                          return item;
                        });
                      });
                      // 先計算原始總價
                      const originalTotalPrice = originalExamItemList.filter(item => (item.selectFlag ?? 1) === 1)
                        .reduce((total, item) => {
                          return total.add(new Decimal(item.examPrice ?? 0));
                        }, new Decimal(0));

                      console.log("originalTotalPrice:", originalTotalPrice.toString());

                      // 用原始總價計算折扣率
                      const discountRate = this.movedDiscountRate(originalTotalPrice);

                      // 再計算折扣後的金額
                      const discountedPackagePrice = originalExamItemList
                        .filter(examInfo => examInfo.selectFlag === 1)
                        .reduce((total, examInfo) => {
                          const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
                          if (examInfo.rateStatus === true) {
                            let discountedPrice = originalPrice.mul(discountRate)
                            let roundedPrice = discountedPrice.div(10).ceil().mul(10); // 無條件進位到十位數
                            // 若有活動折扣率
                            if (this.partyDiscountRate) {
                              roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
                              // 四捨五入到個位整數
                              roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
                            }
                            return total + roundedPrice.toNumber();
                          } else {
                            return total + originalPrice.toNumber();
                          }
                        }, 0);

                      res.data.removeAnesList.forEach(removeItem => {
                        const removedAnesthesiaItem = originalExamItemList.find(item => item.examItem === removeItem.examItem);
                        if (removedAnesthesiaItem && !removeItemQuestionMap.some(item => item.examItem === removedAnesthesiaItem.examItem)) {
                          removeItemQuestionMap.push(removedAnesthesiaItem);
                        }
                      });

                      console.log('discountedPackagePrice:', discountedPackagePrice);
                      console.log('removeItemQuestionMap:', removeItemQuestionMap);
                      this.sharedStorageService.set('originalPrice', discountedPackagePrice);
                      this.sharedStorageService.set('examItemList', originalExamItemList);
                      this.sharedStorageService.set('originalExamItemList', originalExamItemList);
                    }
                    // 若在加選檢項中，刪除加選方案內麻醉項目
                    else if (res?.data?.removeAnesList && res.data.removeAnesList.some(removeItem => 
                      addExamItemList.some(item => item.examItem === removeItem.examItem)
                    )) {
                      console.log("麻醉項目在加選中，將加選項目移除");
                      res.data.removeAnesList.forEach(removeItem => {
                        addExamItemList = addExamItemList.filter(item => item.examItem !== removeItem.examItem);
                      });
                      this.sharedStorageService.set('addExamItemList', addExamItemList);
                    }
                  }
                }

              // 若有移除麻醉項目
              if (res?.data?.removeAnesList && res.data.removeAnesList.length > 0) {
                console.log('有移除項目');
                let examItemList = this.sharedStorageService.get('examItemList') ?? [];
                let originalExamItemList = this.sharedStorageService.get('originalExamItemList') ?? [];
                let addExamItemList = this.sharedStorageService.get('addExamItemList') ?? [];
                console.log("有麻醉項目要移除 :", res.data.removeAnesList);

                // 若在方案內，將方案內項目取消勾選
                if (res?.data?.removeAnesList && res.data.removeAnesList.some(removeItem => 
                  examItemList.some(item => item.examItem === removeItem.examItem)
                )) {
                  console.log("麻醉項目在方案內，將方案內項目取消勾選");
                  res.data.removeAnesList.forEach(removeItem => {
                    originalExamItemList = originalExamItemList.map(item => {
                      if (item.examItem === removeItem.examItem) {
                        item.selectFlag = 0;
                      }
                      return item;
                    });
                  });
                  // 先計算原始總價
                  const originalTotalPrice = originalExamItemList.filter(item => (item.selectFlag ?? 1) === 1)
                    .reduce((total, item) => {
                      return total.add(new Decimal(item.examPrice ?? 0));
                    }, new Decimal(0));

                  console.log("originalTotalPrice:", originalTotalPrice.toString());

                  // 用原始總價計算折扣率
                  const discountRate = this.movedDiscountRate(originalTotalPrice);

                  // 再計算折扣後的金額
                  const discountedPackagePrice = originalExamItemList
                    .filter(examInfo => examInfo.selectFlag === 1)
                    .reduce((total, examInfo) => {
                      const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
                      if (examInfo.rateStatus === true) {
                        let discountedPrice = originalPrice.mul(discountRate);
                        let roundedPrice = discountedPrice.div(10).ceil().mul(10); // 無條件進位到十位數
                        // 若有活動折扣率
                        if (this.partyDiscountRate) {
                          roundedPrice = roundedPrice.mul(new Decimal(this.partyDiscountRate));
                          // 四捨五入到個位整數
                          roundedPrice = new Decimal(Math.round(roundedPrice.toNumber()));
                        }
                        return total + roundedPrice.toNumber();
                      } else {
                        return total + originalPrice.toNumber();
                      }
                    }, 0);

                  console.log('discountedPackagePrice:', discountedPackagePrice);
                  this.sharedStorageService.set('originalPrice', discountedPackagePrice);
                  this.sharedStorageService.set('originalExamItemList', originalExamItemList);
                }
                // 若在加選檢項中，刪除加選方案內麻醉項目
                else if (res?.data?.removeAnesList && res.data.removeAnesList.some(removeItem => 
                  addExamItemList.some(item => item.examItem === removeItem.examItem)
                )) {
                  console.log("麻醉項目在加選中，將加選項目移除");
                  res.data.removeAnesList.forEach(removeItem => {
                    addExamItemList = addExamItemList.filter(item => item.examItem !== removeItem.examItem);
                  });
                  this.sharedStorageService.set('addExamItemList', addExamItemList);
                }
              }
            }
              console.log('準備跳轉至overview頁面');
              this.router.navigate(['/healthcheck/reserve/overview'], {replaceUrl: false}).then((navigationResult: any) => {
                // 將 Map 轉換成普通物件再存儲
                const invalidExamObject: { [key: string]: Array<Question> } = {};
                selectedInvalidItems.forEach((questions, examItem) => {
                  invalidExamObject[examItem] = questions;
                });
                // 將新加的麻醉項目加入到無效檢項清單中
                if (res?.data?.addAnesList && res.data.addAnesList.length > 0 && res?.data?.changeList.length === 0) {
                  let addExamItemList = this.sharedStorageService.get('addExamItemList') ?? [];
                  
                  console.log('有麻醉項目要加 :', res.data.addAnesList);

                    res.data.addAnesList.forEach(addItem => {
                    addExamItemList.push({
                      examName: addItem.examName ?? '',
                      examItem: addItem.examItem,
                      examMemo: addItem.examMemo ?? '',
                      price: addItem.price ?? '0',
                      mutexInfos: [],
                      isNecessary: false,
                      isChoice: true,
                      disable: false,
                      examType: '',
                      deptName: '',
                      deptEName: '',
                    });
                  });
                  this.sharedStorageService.set('addExamItemList', addExamItemList);
                }

                // 將移除的麻醉項目加入到無效檢項清單中
                if (res?.data?.removeAnesList && res.data.removeAnesList.length > 0) {
                  console.log('有麻醉項目要移除 :', res.data.removeAnesList);
                  res.data.removeAnesList.forEach(removedItem => {
                    if (removedItem?.examItem) {
                      // 檢查當前 invalidExamObject 中是否已經有這個特定的檢項
                      if (!invalidExamObject[removedItem.examItem]) {
                        // 找到麻醉相關的問題
                        const anesthesiaQuestions = Array.from(this.invalidExamItemQuestionMap.values())
                          .flat()
                          .filter(q => q.questionId && q.questionnaireTypeId);
                    
                        if (anesthesiaQuestions.length > 0) {
                          const representativeQuestion = anesthesiaQuestions[0];
                          invalidExamObject[removedItem.examItem] = [representativeQuestion];
                        }
                      }
                    }
                  });
                }
                this.sharedStorageService.set('invalidExamQuestionMap', invalidExamObject);
                dialog.close();
              });
            }},
          )},
        });
        dialog.afterClosed().subscribe(() => {
          // 儲存問卷回答狀態
          const questionAnswerObject: { [key: string]: string } = {};
          this.questionAnswerMap.forEach((value, key) => {
            questionAnswerObject[key] = value;
          });
          this.sharedStorageService.set('tempEligibilityQuestionAnswerMap', questionAnswerObject);
          
          // 儲存"以上皆無"的勾選狀態
          this.sharedStorageService.set('tempEligibilityNonOfFollowings', this.nonOfFollowings);

          // 儲存當前無效檢項狀態
          const currentInvalidExamObject: { [key: string]: Array<Question> } = {};
          this.invalidExamItemQuestionMap.forEach((questions, examItem) => {
            currentInvalidExamObject[examItem] = questions;
          });
          this.sharedStorageService.set('tempInvalidExamQuestionMap', currentInvalidExamObject);
        });
      } 
      // 企業預約才有的重選方案
      else {
        let message = `${this.translateService.instant('reserve-confirm-survey.rechoice-dialog-message')} <br/>`;
        message += `<ul class="dialog-remind-msg">`;

        // 避免重複重複訊息
        const displayedMessages = new Set<string>();

        // 判斷不合格項目是否包含麻醉相關檢項
        let hasAnesthesiaInvalid = false;
        selectedInvalidItems.forEach((questions, examItem) => {
          // 檢查是否為麻醉相關檢項（可根據實際的麻醉檢項代碼調整）
          console.log("EXAMITEM:", examItem);
          if (examItem.includes('PE001006') || examItem.includes('PE001005') || examItem.includes('PE001000') || examItem.includes('PE001007')) {
            hasAnesthesiaInvalid = true;
          }
          const examName = this.examItemMap.has(examItem)
            ? this.examItemMap.get(examItem)?.examName
            : this.groupMap.get(examItem)?.groupName;

          questions.forEach(question => {
            const translated = this.translateService.instant(
              'reserve-confirm-survey.invalid-dialog-item-message',
              {
                questionName: question.questionName,
                examName: examName,
              }
            );

            if (!displayedMessages.has(translated)) {
              displayedMessages.add(translated);
              message += `<li>${translated}</li>`;
            }
          });
        });

        message += `</ul>`;

        const dialog = this.dialog.open(SingleActionDialogComponent, {
          data: {
            title: this.translateService.instant('reserve-confirm-survey.rechoice-dialog-title'),
            message: message,
            buttonText: this.translateService.instant('reserve-confirm-survey.rechoice-dialog-button'),
            showCloseButton: false,
            action: () => {
              this.sharedStorageService.remove('tempEligibilityNonOfFollowings');
              this.sharedStorageService.remove('tempInvalidExamQuestionMap');
              this.sharedStorageService.remove('tempEligibilityQuestionAnswerMap');
              this.sharedStorageService.remove('removeItemQuestionMap');
              this.sharedStorageService.remove('indicationsQuestionList');
              this.sharedStorageService.remove('mutexItems');
              this.sharedStorageService.remove('originalExamItemList');
              this.sharedStorageService.remove('packagePrice');
              this.sharedStorageService.remove('paymentAmount');
              this.sharedStorageService.remove('addExamItemList');
              this.sharedStorageService.remove('invalidExamQuestionMap');
              this.sharedStorageService.remove('businessSelectedPackage');
              this.sharedStorageService.remove('examItemList');
              this.router.navigate(['/healthcheck/reserve/companyplan']).then();
              dialog.close();
            },
          },
        });
      }
    }
  }

  // 新增方法：取得選擇方案底下有問題的檢項
  private getSelectedInvalidItems(): Map<string, Array<Question>> {
    const selectedInvalidItems = new Map<string, Array<Question>>();

    // 取得目前選擇的方案檢項
    const selectedExamItems = this.getSelectedExamItems();

    // 只保留選擇方案中的無效檢項
    this.invalidExamItemQuestionMap.forEach((questions, examItem) => {
      if (selectedExamItems.has(examItem)) {
        selectedInvalidItems.set(examItem, questions);
      }
    });

    console.log('selectedInvalidItems:', selectedInvalidItems);

    return selectedInvalidItems;
  }

  // 新增方法：取得目前選擇的所有檢項
  private getSelectedExamItems(): Set<string> {
    const selectedItems = new Set<string>();

    if (this.isPersonalReserve) {
      // 個人預約：加入方案檢項 (只加入已勾選的檢項)
      const examItemList = this.sharedStorageService.get('examItemList');
      if (examItemList) {
        examItemList
          .filter(examInfo => {
            return examInfo.selectFlag;
          })
          .forEach((examItem: ExamInfo) => {
            selectedItems.add(examItem.examItem);
          });
      }
    } else {
      // 企業預約：加入企業方案檢項 (只加入已勾選的檢項)
      const examItemList = this.sharedStorageService.get('examItemList');
      if (examItemList) {
        examItemList.forEach((examItem: ExamInfo) => {
          selectedItems.add(examItem.examItem);
        });
      }
    }

    // 加入加選檢項
    this.sharedStorageService
      .get('addExamItemList')
      ?.forEach((examItem: AddExamInfo) => {
        selectedItems.add(examItem.examItem);
      });
      console.log('selectedItems:', selectedItems);
    return selectedItems;
  }

  // 計算動態折扣率
  movedDiscountRate(originalPrice: Decimal) {
    console.log("計算折扣率 - originalPrice:", originalPrice.toString());
        
    // 防護：如果 originalPrice 為負數或零，返回基礎折扣率
    if (originalPrice.lte(0)) {
      console.warn("originalPrice 異常:", originalPrice.toString());
      return new Decimal(1);
    }

    const userPlanResponse = this.sharedStorageService.get('userPlanResponse');

    //取得原始售價(未折扣)
    const allcheckupPrice = new Decimal(userPlanResponse?.allCheckup?.packageList.reduce((total, packageInfo) => {
      const packageTotal = packageInfo.examItemList.reduce((sum, examInfo) => {
        const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
        return sum + originalPrice.toNumber();
      }, 0);
      return total + packageTotal;
    }, 0) ?? 0);
    const aiExclusivePrice = new Decimal(userPlanResponse?.aiExclusive?.packageList.reduce((total, packageInfo) => {
      const packageTotal = packageInfo.examItemList.reduce((sum, examInfo) => {
        const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
        return sum + originalPrice.toNumber();
      }, 0);
      return total + packageTotal;
    }, 0) ?? 0);
    const basicCheckupPrice = new Decimal(userPlanResponse?.basicCheckup?.packageList.reduce((total, packageInfo) => {
      const packageTotal = packageInfo.examItemList.reduce((sum, examInfo) => {
        const originalPrice = new Decimal(examInfo.examPrice) || new Decimal(0);
        return sum + originalPrice.toNumber();
      }, 0);
      return total + packageTotal;
    }, 0) ?? 0);

    // 取得原始折扣率
    const allCheckupRate = new Decimal(userPlanResponse?.allCheckup?.discountRate ?? 0);
    const aiExclusiveRate = new Decimal(userPlanResponse?.aiExclusive?.discountRate ?? 0);
    const basicCheckupRate = new Decimal(userPlanResponse?.basicCheckup?.discountRate ?? 0);
    
    // 當目前原價大於等於全方位方案價格時
    if (originalPrice.gte(allcheckupPrice)) {
      console.log("使用全方位折扣率");
      return allCheckupRate;
    } 
    // 當目前原價大於等於智能專屬方案價格時
    else if (originalPrice.gte(aiExclusivePrice)) {
      if (originalPrice.eq(aiExclusivePrice)) {
        console.log("使用智能專屬折扣率");
        return aiExclusiveRate;
      }
      console.log("計算全方位與智能專屬之間的折扣率");
      return allCheckupRate.sub(
        (allCheckupRate.sub(aiExclusiveRate))
          .mul((allcheckupPrice.sub(originalPrice)))
          .div((allcheckupPrice.sub(aiExclusivePrice)))
      );
    } 
    // 當目前原價大於等於基礎方案價格時
    else if (originalPrice.gte(basicCheckupPrice)) {
      if (originalPrice.eq(basicCheckupPrice)){
        console.log("使用基礎折扣率");
        return basicCheckupRate;
      }
      console.log("計算智能專屬與基礎之間的折扣率");
      return aiExclusiveRate.sub(
        ((aiExclusiveRate.sub(basicCheckupRate))).mul((aiExclusivePrice.sub(originalPrice)))
          .div((aiExclusivePrice.sub(basicCheckupPrice)))
      );
    } 
    // 當目前原價小於基礎方案價格時
    else {
      console.log("使用基礎折扣率");
      return new Decimal(basicCheckupRate);
    }
  }

  protected readonly BMI = BMI;
  protected readonly API_PARAMS = API_PARAMS;

  // 檢查企業預約中的無效檢項是否在加選項目
  private hasInvalidAddItems(selectedInvalidItems: Map<string, Array<Question>>): boolean {
    const addExamItemList = this.sharedStorageService.get('addExamItemList') ?? [];
    const addExamItems = new Set(addExamItemList.map((item: AddExamInfo) => item.examItem));
    
    // 檢查無效檢項中是否有任何一個是加選項目
    for (const examItem of selectedInvalidItems.keys()) {
      if (addExamItems.has(examItem)) {
        return true;
      }
    }
    
    return false;
  }

  // 檢查企業預約中的無效檢項是否在方案內
  private hasInvalidItemsInPackage(selectedInvalidItems: Map<string, Array<Question>>): boolean {
    const examItemList = this.sharedStorageService.get('examItemList') ?? [];
    const packageExamItems = new Set(examItemList.map((item: ExamInfo) => item.examItem));
    
    // 檢查無效檢項中是否有任何一個是方案內項目
    for (const examItem of selectedInvalidItems.keys()) {
      if (packageExamItems.has(examItem)) {
        return true;
      }
    }
    
    return false;
  }
}
